import React from 'react';
import { format12HourTime, formatShortWeekdayMonthDay } from 'shared/Dates';
import { ProviderMatch, JobMatch } from '../substituteModels';
import AdminTable from 'internal/shared/tables/AdminTable';
import Row from 'internal/shared/tables/Row';
import { TableCell } from '@mui/material';
import GroupAdd from '@mui/icons-material/GroupAdd';
import { Colors, Text } from 'library';

const columns = ['appointment', 'expires', 'accepted', 'declined', 'hiring group created'];
export default function SentMatchesTable({
    matches,
    header,
    userId,
}: {
    matches: ProviderMatch[] | JobMatch[];
    header: React.ReactNode;
    userId?: number;
}) {
    return (
        <AdminTable columns={columns} header={header}>
            {matches.map((row) => (
                <Row key={row.id}>
                    <TableCell>
                        {formatShortWeekdayMonthDay(row.appointment.start_date)}{' '}
                        {format12HourTime(row.appointment.start_date)} - {format12HourTime(row.appointment.end_date)} (
                        {row.appointment.id})
                        {row.appointment.preferred_sitters?.preferred_sitters.some(
                            (x) => userId && x.sitter === userId,
                        ) ? (
                            <GroupAdd
                                titleAccess="Preferred provider"
                                style={{
                                    color: Colors.mediumRed,
                                    marginLeft: 8,
                                }}
                            />
                        ) : (
                            ''
                        )}
                        <Text variant="body2">
                            Created by: {row.created_by?.first_name} {row.created_by?.last_name} ({row.created_by?.id})
                        </Text>
                    </TableCell>
                    <TableCell>
                        {row.expires_at
                            ? `${formatShortWeekdayMonthDay(row.expires_at)} ${format12HourTime(row.expires_at)}`
                            : ''}
                    </TableCell>
                    <TableCell>
                        {row.accepted_at
                            ? `${formatShortWeekdayMonthDay(row.accepted_at)} ${format12HourTime(row.accepted_at)}`
                            : ''}
                    </TableCell>
                    <TableCell>
                        {row.declined_at
                            ? `${formatShortWeekdayMonthDay(row.declined_at)} ${format12HourTime(row.declined_at)}`
                            : ''}
                    </TableCell>
                    <TableCell>
                        {row.hiring_group_opened_at
                            ? `${formatShortWeekdayMonthDay(row.hiring_group_opened_at)} ${format12HourTime(row.hiring_group_opened_at)}`
                            : ''}
                    </TableCell>
                </Row>
            ))}
        </AdminTable>
    );
}
